import { render, staticRenderFns } from "./GeneralCultureSignificance.vue?vue&type=template&id=0c9a05cb&"
import script from "./GeneralCultureSignificance.vue?vue&type=script&lang=ts&"
export * from "./GeneralCultureSignificance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports